import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../../../assets/svg/logo.svg';

function NavLinks({ doClose }) {
    return (
        <>
            <div className={'navbar-links'}>
                <Logo className={'navbar-logo'} />
                <Link onClick={doClose} className={'navbar-links__link'} to="/">
                    Home
                </Link>
                <Link onClick={doClose} className={'navbar-links__link'} to="/dogs">
                    Puppies & Adults
                </Link>
                <Link onClick={doClose} className={'navbar-links__link'} to="/gallery">
                    Gallery
                </Link>
                <Link onClick={doClose} className={'navbar-links__link'} to="/contacts">
                    Contacts
                </Link>
            </div>
        </>
    );
}

export default NavLinks;
